export default "__VITE_ASSET__CJ8u$RM___"